import { Theme } from "@emotion/react";
import styled from "@emotion/styled";

interface TextProps {
  size?: keyof Theme["fontSizes"]; // H1, H2, H3, xl, lg, md, sm, xs, xxs
  bold?: boolean;
}

const baseHeading = {
  lineHeight: 1.2,
  marginTop: 0,
  marginBottom: "1.5rem",
  "*+&": {
    marginTop: "2.5rem",
  },
};

const H1 = styled.h1<TextProps>(
  baseHeading,
  ({ bold = true, size = "h1", theme }) => ({
    fontSize: theme.fontSizes[size],
    fontWeight: bold ? "bold" : "normal",
  })
);

const H2 = styled.h2<TextProps>(
  baseHeading,
  ({ bold = true, size = "h2", theme }) => ({
    fontSize: theme.fontSizes[size],
    fontWeight: bold ? "bold" : "normal",
  })
);

const H3 = styled.h3<TextProps>(
  baseHeading,
  ({ bold = true, size = "h3", theme }) => ({
    ...theme.fonts.body,
    fontSize: theme.fontSizes[size],
    fontWeight: bold ? "bold" : "normal",
    marginBottom: "1rem",
  })
);
const H4 = styled.h4<TextProps>(
  baseHeading,
  ({ bold = true, size = "sm", theme }) => ({
    ...theme.fonts.body,
    fontSize: theme.fontSizes[size],
    fontWeight: bold ? "bold" : "normal",
    marginBottom: "1rem",
  })
);
const H5 = styled.h5<TextProps>(
  baseHeading,
  ({ bold = true, size = "xs", theme }) => ({
    ...theme.fonts.display,
    fontSize: theme.fontSizes[size],
    fontWeight: bold ? "bold" : "normal",
  })
);
const H6 = styled.h6<TextProps>(
  baseHeading,
  ({ bold = true, size = "xs", theme }) => ({
    ...theme.fonts.display,
    fontSize: theme.fontSizes[size],
    fontWeight: bold ? "bold" : "normal",
  })
);

const Text = styled.p<TextProps>(({ bold = false, size = "sm", theme }) => ({
  fontSize: theme.fontSizes[size],
  fontWeight: bold ? "bold" : "normal",
  marginTop: 0,
  marginBottom: ["lg", "xl"].includes(size)
    ? theme.spacing.lg
    : theme.spacing.md,
}));

export { H1, H2, H3, H4, H5, H6, Text };
